import { Grid, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import SumInsuredLabelvaluepair from './SumInsuredLabelvaluepair';
import EmployeeList from './SumInsuredItems/EmployeeList';
import AssetList from './SumInsuredItems/AssetList';
import AnimalList from './SumInsuredItems/AnimalList';


function SumInsured({
  sumInsuredDatas,
  customerId = null,
  rfqId,
  usedfrom = null,
  showTotal = true,
  showDataList = false,
  customerType = null,
  rfqDetails = null,
  placementSlip = false,
  type = null,
  policyDetail = null,
  qcRemarkOfEachSections = null,
  checkAllModuleIsVerified = null,
  setQcRemarkOfEachSections = null,
  EndorsementCompareQcRemarks = null
}) {
  const [insuredGroups, setInsuredGroups] = useState([]);
  const [totalSumInsuredAmount, setTotalSumInsuredAmount] = React.useState(0);

  React.useEffect(() => {
    sumInsuredDatas.map((data) => {
      if (data.totalSumInsured > 0) {
        return setTotalSumInsuredAmount(
          (prevTotal) => prevTotal + parseInt(data.totalSumInsured)
        );
      }
    });
  }, []);

  return (
    <>
      {' '}
      {sumInsuredDatas && (
        <div id="sumInsuredBox">
          {/* <Typography gutterBottom variant="h4" component="div" >
           Sum Insured
   </Typography> */}

          {sumInsuredDatas?.map((sumInsuredData) => {

            return (
              <>
                {sumInsuredData?.type === 'labelValuePairList' ? (
                  <>
                    <SumInsuredLabelvaluepair
                      sumInsuredData={sumInsuredData}
                      rfqId={rfqId}
                      type={type}
                      policyDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      checkAllModuleIsVerified={checkAllModuleIsVerified}
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                      EndorsementCompareQcRemarks={EndorsementCompareQcRemarks}
                    />

                  </>
                ) : sumInsuredData?.type === 'employeeList' ? (
                  <>
                    <EmployeeList
                      rfqDetails={rfqDetails}
                      usedfrom={usedfrom}
                      showDataList={showDataList}
                      rfqId={rfqId}
                      sectionId={sumInsuredData.id}
                      sumInsuredData={sumInsuredData}
                      placementSlip={placementSlip}
                      type={type}
                      policyDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      checkAllModuleIsVerified={checkAllModuleIsVerified}
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                      EndorsementCompareQcRemarks={EndorsementCompareQcRemarks}
                    />

                  </>
                ) : sumInsuredData?.type === 'assetList' ? (
                  <>
                    <AssetList
                      rfqDetails={rfqDetails}
                      showDataList={showDataList}
                      rfqId={rfqId}
                      sectionId={sumInsuredData.id}
                      sumInsuredData={sumInsuredData}
                      placementSlip={placementSlip}
                      type={type}
                      policyDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      checkAllModuleIsVerified={checkAllModuleIsVerified}
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                      EndorsementCompareQcRemarks={EndorsementCompareQcRemarks}
                    />

                  </>
                ) : sumInsuredData?.type === 'animalList' ? (
                  <>
                    <AnimalList
                      rfqDetails={rfqDetails}
                      showDataList={showDataList}
                      rfqId={rfqId}
                      sectionId={sumInsuredData.id}
                      sumInsuredData={sumInsuredData}
                      placementSlip={placementSlip}
                      type={type}
                      policyDetail={policyDetail}
                      qcRemarkOfEachSections={qcRemarkOfEachSections}
                      checkAllModuleIsVerified={checkAllModuleIsVerified}
                      setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                      EndorsementCompareQcRemarks={EndorsementCompareQcRemarks}
                    />

                  </>
                ) : null}
              </>
            );
          })}

          {showTotal && !showDataList && (
            <Grid
              item
              xs={12}
              style={{
                paddingBottom: 6,
                border: '1px solid #b6adad',
                borderRadius: 10,
                margin: '5px',
                position: 'relative'
              }}
            >
              <Stack direction="row" className="clause-item">
                <div
                  style={{
                    width: type === 'qc' ? '80%' : '89%',
                    textAlign: 'right',
                    paddingRight: '27px'
                  }}
                >
                  <Typography variant="h5" style={{ marginTop: 9 }}>
                    {'Total Sum Insured for All Sections'}
                  </Typography>
                </div>
                <div
                  style={{
                    width: type === 'qc' ? '20%' : '12%',
                    textAlign: 'left'
                  }}
                >
                  <Grid style={{ fontWeight: 'bold', marginTop: 9 }}>
                    : {new Intl.NumberFormat('en-IN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(Number(totalSumInsuredAmount ?? 0))}
                  </Grid>
                </div>
              </Stack>
            </Grid>
          )}
        </div>
      )}
    </>
  );
}

export default SumInsured;
